import * as React from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
    Box,
    Breakpoint,
    Button,
    CircularProgress,
    Fade,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { theme } from "../../framework/theme";
import { ReactNode } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { t } from "i18next";

export interface MuiDialogProps {
    open: boolean;
    title: string;
    children: ReactNode;
    maxWidth?: false | Breakpoint;
    loading?: boolean;
    onSave?: () => void;
    saveLabel?: string;
    onClose?: () => void;
    disabled?: boolean;
}

export const MuiDialog = (props: MuiDialogProps) => {
    const {
        open,
        title,
        children,
        onClose,
        maxWidth = "xl",
        loading = false,
        saveLabel,
        onSave,
        disabled,
    } = props;
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            maxWidth={maxWidth}
            onClose={onClose}
            TransitionComponent={Fade}
            fullWidth
        >
            <DialogTitle>
                <Grid2
                    container
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h2">{title}</Typography>

                    <IconButton size="small" color="primary" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Grid2>
            </DialogTitle>
            <DialogContent dividers>
                {loading ? (
                    <Box display="flex" justifyContent="center" p={2}>
                        <CircularProgress />
                    </Box>
                ) : (
                    children
                )}
            </DialogContent>
            {loading ? null : (
                <DialogActions
                    className="mx-3 my-2"
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Button
                        color="success"
                        disabled={disabled}
                        variant="contained"
                        onClick={onSave}
                    >
                        {saveLabel ?? t("common.save")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        disabled={disabled}
                        onClick={onClose}
                        sx={{ mr: 2 }}
                    >
                        {t("common.cancel")}
                    </Button>

                    <div className="flex-grow" />
                </DialogActions>
            )}
        </Dialog>
    );
};
